import React from "react";
import "../styles/VideoPlayerDescription.css";

const VideoPlayerDescription = ({ description }) => {
    return (
      <div className="videoplayer-video-description">
        <span>{description ? description : "No Description Available"}</span>
      </div>
    );
  }
  
  export default VideoPlayerDescription;